import { Outlet } from "react-router-dom";
import { useState, useEffect } from "react";
import axios from "~/src/api/axios";
import useUserData from "../../hooks/useUserData";

const PersistLogin = () => {
  const [isLoading, setIsLoading] = useState(true);
  const { userData, setUserData } = useUserData();
  useEffect(() => {
    const verifyRefreshToken = async () => {
      try {
        await axios
          .get("/core_api/user-data", { withCredentials: true })
          .then((response) => {
            if (response.status == 200) {
              setUserData({
                ...response.data,
                isLoggedIn: true,
                subscriptionStatus: {
                  enabled: response.data.user_plan.name == "subscription",
                  endDate: response.data.user_plan.subscription_renewal_date,
                  isCanceled: response.data.user_plan.subscription_cancelled,
                },
                isLegacyUser: response.data.legacy_user,
              });
            }
          });
      } catch (error) {
        console.error(error);
      } finally {
        setIsLoading(false);
      }
    };
    !userData?.isLoggedIn ? verifyRefreshToken() : setIsLoading(false);
  }, []);
  return <>{isLoading ? <div>Loading...</div> : <Outlet />}</>;
};

export default PersistLogin;
